import React, {useEffect, useState} from 'react';
import GoogleMapReact from 'google-map-react';
import MapMarker from "./MapMarker";
import PropTypes from "prop-types";
import {useCallbackRef} from "use-callback-ref";

function GoogleMap ({ accommodations, closeModal, selectedAccommodation, setSelectedAccommodation }) {

    const filteredAccommodations = accommodations.filter(accommodation => accommodation.mapLongitude !== '' && accommodation.mapLongitude !== null && accommodation.mapLatitude !== '' && accommodation.mapLatitude !== null)

    const [calculatedBounds, setCalculatedBounds] = useState(null);

    const mapRef = useCallbackRef(null, () => {
        if (selectedAccommodation !== null){
            zoomAndPanToCoordinate(parseFloat(selectedAccommodation.mapLatitude), parseFloat(selectedAccommodation.mapLongitude))
        } else {
            fitBoundsToAccommodations();
        }
    });

    const mapsRef = useCallbackRef(null, () => {
        const latLngList = filteredAccommodations.map((accommodation) => new mapsRef.current.LatLng(parseFloat(accommodation.mapLatitude), parseFloat(accommodation.mapLongitude)))
        const currentBounds = new mapsRef.current.LatLngBounds()

        latLngList.forEach((latLng) => currentBounds.extend(latLng));

        setCalculatedBounds(currentBounds)
    });

    const defaultMapValues = {
        center: {
            lat: 67.60486028218646,
            lng: 24.156388261233744
        },
        zoom: 8,
    };

    useEffect(() => {
        if (selectedAccommodation !== null){
            zoomAndPanToCoordinate(parseFloat(selectedAccommodation.mapLatitude), parseFloat(selectedAccommodation.mapLongitude));
        } else {
            if (mapRef.current !== null && mapsRef.current !== null) {
                fitBoundsToAccommodations();
            }
        }
    }, [selectedAccommodation]);

    const fitBoundsToAccommodations = () => {
        mapRef.current.setCenter(calculatedBounds.getCenter());
        mapRef.current.fitBounds(calculatedBounds);

        // quick and dirty fix to handle map zoom if just one accommodation is available
        if (filteredAccommodations.length === 1) {
            mapRef.current.setZoom(14);
        }
    }

    const zoomAndPanToCoordinate = (mapLatitude, mapLongitude, zoomNumber = 16) => {
        if(mapRef.current !== null) {
            mapRef.current.panTo({lat: mapLatitude, lng: mapLongitude});
            mapRef.current.setZoom(zoomNumber);
        }
    }
    const handleMarkerClick = (accommodation, e) => {
        if (e) {
            e.stopPropagation();
        }
        setSelectedAccommodation(accommodation);
    }
    return (
        <div>
            <div style={{ height: '450px', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: "AIzaSyDyFZ9o7gYhsKcwiLOtKtnyRxMnkQcVztM" }}
                    defaultCenter={defaultMapValues.center}
                    defaultZoom={defaultMapValues.zoom}
                    onClick={() => setSelectedAccommodation(null)}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }) => {
                        mapsRef.current = maps;
                        mapRef.current = map;

                    }}
                >

                    {
                        filteredAccommodations.map((accommodation, index) =>
                            <MapMarker
                                key={index}
                                name={accommodation.name}
                                uid={accommodation.uid}
                                lat={parseFloat(accommodation.mapLatitude)}
                                lng={parseFloat(accommodation.mapLongitude)}
                                closeModal={closeModal}
                                selected={selectedAccommodation !== null && selectedAccommodation.uid === accommodation.uid}
                                onClick={(e) => handleMarkerClick(accommodation, e)}                            />
                        )
                    }
                </GoogleMapReact>
            </div>
        </div>
    );
}

GoogleMap.propTypes = {
    accommodations: PropTypes.array,
    closeModal: PropTypes.func,
    onBoundChange: PropTypes.func,
    selectedAccommodation: PropTypes.any,
    setSelectedAccommodation: PropTypes.func
};

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/Map/GoogleMap.js